import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { salesloftQueryKeys } from "./queryKeyFactory";

const CONNECTION_PROBE_PAGE_SIZE = 1;

type UseSalesloftConnectionProbeQueryParams = {
    enabled?: boolean;
};

/**
 * Smallest cadences request that still surfaces a 403 for an expired connection. Cached under its
 * own key: the picker's key omits `pageSize`/`includeSteps`, so sharing it would hand the picker
 * a single step-less cadence.
 */
export const useSalesloftConnectionProbeQuery = ({ enabled = true }: UseSalesloftConnectionProbeQueryParams = {}) =>
    useQuery({
        queryKey: salesloftQueryKeys.connectionProbe(),
        queryFn: () =>
            salesApiService.salesloft.fetchCadences({
                page: 1,
                pageSize: CONNECTION_PROBE_PAGE_SIZE,
                includeSteps: false,
            }),
        enabled,
    });
